'use es6';

import { List, Record } from 'immutable';
import I18n from 'I18n';
import { DRAFT_STATES, ERROR_STATES, PageState, PUBLISHED_STATES, SCHEDULED_STATES, THUNDERDOME_STATES } from '../constants/base';
const DEFAULTS = {
  archived: false,
  contentStatus: '',
  id: 0,
  language: '',
  masterId: 0,
  name: '',
  password: '',
  previewKey: '',
  publicAccessRules: List(),
  publicAccessRulesEnabled: false,
  published: false,
  slug: '',
  state: '',
  updated: 0
};
const getTranslatedContentStatus = ({
  publishDate,
  state
}) => {
  if (state === PageState.PUBLISHED_OR_SCHEDULED) {
    if (publishDate && I18n.moment().isSameOrBefore(publishDate)) {
      return 'scheduled';
    }
    return 'published';
  } else if (PUBLISHED_STATES.includes(state)) {
    return 'published';
  } else if (DRAFT_STATES.includes(state)) {
    return 'draft';
  } else if (SCHEDULED_STATES.includes(state)) {
    return 'scheduled';
  } else if (ERROR_STATES.includes(state)) {
    return 'error';
  } else if (THUNDERDOME_STATES.includes(state)) {
    return 'thunderdome';
  }
  return 'default';
};
export default class TranslatedContent extends Record(DEFAULTS) {
  static fromJS(data) {
    const {
      archived,
      id,
      language,
      masterId,
      name,
      password,
      previewKey,
      publicAccessRules,
      publicAccessRulesEnabled,
      published,
      state,
      slug,
      updated
    } = data;
    return new TranslatedContent(Object.assign({}, DEFAULTS, {
      archived,
      contentStatus: getTranslatedContentStatus(data),
      id,
      language,
      masterId,
      name,
      password,
      previewKey,
      publicAccessRules,
      publicAccessRulesEnabled,
      published,
      slug,
      state,
      updated
    }));
  }
}